import { useEffect, useState } from 'react';

import Axios from '../../../networking/intraceptor';
import { inventory_accountability_setup_status } from '../../../networking/urlEndPoints';

// Handover requests may arrive through a real-time payload created before the
// latest backend was deployed. Verify setup through the canonical Inventory
// endpoint so a missing handover flag cannot incorrectly hide the controls.
const useInventorySetupCompleted = (pharmacyId) => {
    const [setupCompleted, setSetupCompleted] = useState(null);

    useEffect(() => {
        let cancelled = false;

        if (!pharmacyId) {
            setSetupCompleted(false);
            return () => { cancelled = true; };
        }

        setSetupCompleted(null);
        Axios.get(inventory_accountability_setup_status)
            .then((response) => {
                if (!cancelled) {
                    setSetupCompleted(response?.data?.data?.setup_completed === true);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    // null means verification failed. Callers may safely use a
                    // true setup flag supplied by the handover API as fallback.
                    setSetupCompleted(null);
                }
            });

        return () => { cancelled = true; };
    }, [pharmacyId]);

    return setupCompleted;
};

export default useInventorySetupCompleted;
